<div id="modalHeader">
  <img id="closeImage" src="assets/images/button_close.svg" (click)="closeModal()" />
</div>
<div id="emailOnlyModalText">The information you entered is incorrect. Please try again.</div>